import { LegacyTask } from '../task/legacy-task.model';
import { ActivityCallActivity } from 'ng2-app/modules/task-management/models/call-activity/activity-call-activity.class';


export class CallActivity extends LegacyTask {
    tasks: ActivityCallActivity[];
}
